import React from 'react';
import { motion } from 'framer-motion';
import { MonitorOff, Brain, Sparkles, ArrowRight } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: <MonitorOff className="w-8 h-8 text-[#1E3A5F]" data-id="element-10" />,
    title: 'Reduce el tiempo frente a pantallas sin conflictos',
    description: 'Estrategias probadas para desconectar sin llantos ni resistencia.'
  }, {
    icon: <Brain className="w-8 h-8 text-[#1E3A5F]" data-id="element-11" />,
    title: 'Mejora la concentración y el comportamiento',
    description: 'Actividades diseñadas para estimular el foco y la calma.'
  }, {
    icon: <Sparkles className="w-8 h-8 text-[#1E3A5F]" data-id="element-12" />,
    title: 'Actividades prácticas listas para aplicar hoy mismo',
    description: 'Material imprimible y guías paso a paso para padres ocupados.'
  }];
  return <section className="py-12 px-4 bg-white" data-id="element-13">
      <div className="max-w-2xl mx-auto" data-id="element-14">
        <div className="space-y-6" data-id="element-15">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-5 rounded-xl border border-gray-100 shadow-sm bg-[#F5F1E8]" data-id="element-16">
              <div className="bg-white p-3 rounded-lg shadow-sm shrink-0" data-id="element-17">
                {benefit.icon}
              </div>
              <div data-id="element-18">
                <h3 className="font-bold text-[#1E3A5F] text-lg leading-tight mb-2" data-id="element-19">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-20">
                  {benefit.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-10 text-center" data-id="element-21">
          <p className="text-lg font-medium text-[#1E3A5F] mb-6" data-id="element-22">
            "Sin teorías largas. Sin métodos complicados. Resultados prácticos
            desde la primera semana."
          </p>

          <motion.a href="https://mpago.li/2MQSj3Q" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center gap-2 bg-[#22C55E] hover:bg-[#16A34A] text-white font-bold py-3 px-8 rounded-full shadow-md transition-all" data-id="element-23">
            QUIERO APROVECHAR LA PROMO
            <ArrowRight className="w-5 h-5" data-id="element-24" />
          </motion.a>
        </div>
      </div>
    </section>;
}